import { ApplicationsAPI } from "api/api/applicationsApi/applicationsApi";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  PostApplicationsPwdBody,
  PostApplicationsPwdResponse,
} from "api/api/applicationsApi/types";

export const postApplicationsPwd = createAsyncThunk<
  PostApplicationsPwdResponse,
  PostApplicationsPwdBody
>("applications/postApplicationsPwd", async (body, { rejectWithValue }) => {
  try {
    const data = await ApplicationsAPI.postApplicationsPwd(body);
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("Error while posting applications pwd", error.response?.data);
      return rejectWithValue(error.response?.data || "Unknown error");
    } else {
      console.error("Error while posting applications pwd", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});